var _style, _desc;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnimatedTarget(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\n\t      .cls-1 {\n        fill: none;\n        stroke: #231f20;\n        stroke-miterlimit: 10;\n\t\tstroke-width: 3px;\n      }\n\t\n@keyframes a0_t { 0% { transform: translate(24px,24px) scale(0.7,1) translate(-18px,-2px); animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 33.3333% { transform: translate(24px,24px) scale(1,1) translate(-18px,-2px); animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 100% { transform: translate(24px,24px) scale(0.7,1) translate(-18px,-2px); } }\n@keyframes a1_t { 0% { transform: translate(24px,24px) rotate(90deg) scale(0.7,1) translate(-18px,-2px); animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 33.3333% { transform: translate(24px,24px) rotate(90deg) scale(1,1) translate(-18px,-2px); animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 100% { transform: translate(24px,24px) rotate(90deg) scale(0.7,1) translate(-18px,-2px); } }\n@keyframes a2_t { 0% { transform: scale(0.7,0.7); animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 33.3333% { transform: scale(1,1); animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 100% { transform: scale(0.7,0.7); } }\n    ")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Animated target") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created by Yodigito")), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 4,
    fill: "#10303C",
    rx: 2.1,
    stroke: "none",
    transform: "translate(24,24) scale(0.7,1) translate(-18,-2)",
    style: {
      animation: "a0_t 1s linear infinite both"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 4,
    fill: "#10303C",
    rx: 2.1,
    stroke: "none",
    transform: "translate(24,24) rotate(90) scale(0.7,1) translate(-18,-2)",
    style: {
      animation: "a1_t 1s linear infinite both"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 24,
    cy: 24,
    r: 10,
    style: {
      animation: "a2_t 1s linear infinite both",
      transformOrigin: "center"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedTarget);
export default __webpack_public_path__ + "static/media/animated-target.16730154dc0a5962f9db2e7fe53b9a29.svg";
export { ForwardRef as ReactComponent };